import { AnimatedCheckbox } from '@components/checkbox';
import { AnimatedRadio } from '@components/radio-group/animated-radio';

import { multiSelectComparers } from './filter-utils';
import { CurrentFilterState } from './use-current-filter';

export function FilterSelectionIcon({
  isSelected,
  state,
}: {
  isSelected: boolean;
  state: CurrentFilterState;
}) {
  const isMultiComparer = state.comparer ? multiSelectComparers.includes(state.comparer) : false;
  if (isMultiComparer) {
    return <AnimatedCheckbox checked={isSelected} />;
  }
  return <AnimatedRadio checked={isSelected} />;
}
